import React from "react";
import ReactQuill, { Quill } from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

// Use class-based alignment so the output is:
//   <p class="ql-align-center"> ... </p>
// This keeps alignment persistable via DOMPurify's `class` allow-list.
const AlignClass = Quill.import("attributors/class/align");
Quill.register(AlignClass, true);

/**
 * Rich text editor for the admin News module.
 * Value is HTML. Toolbar covers headings, sizes, bold/italic/underline,
 * text color, alignment, lists, blockquote, links.
 */
const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }],
    [{ align: [] }, { align: "center" }, { align: "right" }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "align",
  "list",
  "blockquote",
  "link",
];

export default function RichTextEditor({ value, onChange, placeholder }) {
  return (
    <div className="rich-editor" data-testid="rich-editor">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
}
